<template>
	<MobileLayout>
		<template #header>
			<div ref="menuShellRef" class="diagens-mob-menu-shell">
				<MobileMenu :menus="getMenus" @change="changeMenu" />
			</div>
		</template>
		<template #content>
			<CoreCacheRouter />
		</template>
		<template #floating>
			<SmartLayoutC compId="layout_floating" mode="basic-mobile" key="layout_floating" />
		</template>
	</MobileLayout>
</template>

<script setup>
import { computed, inject, ref, onMounted, onBeforeUnmount, nextTick } from 'vue';
import MobileMenu from '@/views/layout/components/mobileMenu';
import { useNavigation } from '@rebuild/hooks/useNavigation';
import MobileLayout from '@rebuild/materials/shared/layout_wrapper/MobileLayout.vue';
import SmartLayoutC from '@rebuild/components/SmartLayoutC.vue';
import CoreCacheRouter from '@rebuild/materials/shared/layout_wrapper/CoreCacheRouter.vue';
import i18n, { EN, ZH_HK } from '@/locales';

// Add font
document.body.classList.add('is-diagens');

const menuShellRef = ref(null);
const isEN = computed(() => i18n.locale === EN);
const isZH_HK = computed(() => i18n.locale === ZH_HK);
// 原标题脱布局隐藏，插入 div 与 logo 同行
const HIDE_NAME = 'display:none';

let titlePatch = null;

function resetMenuTitlePatch() {
	if (!titlePatch) return;
	titlePatch.div.remove();
	titlePatch.name.style.cssText = titlePatch.prev;
	titlePatch = null;
}

function applyMenuTitlePatch() {
	const root = menuShellRef.value;
	if (!root) return;
	resetMenuTitlePatch();
	const name = root.querySelector('.mobile-menu-name');
	if (!name?.parentNode) return;
	const prev = name.getAttribute('style') ?? '';
	name.style.cssText = HIDE_NAME;
	const div = document.createElement('div');
	div.className = 'diagens-mob-menu-brand-inline';
	div.textContent = isEN.value ? 'DIAGENS' : isZH_HK.value ? '德適生物' : '德适生物';
	name.parentNode.insertBefore(div, name);
	titlePatch = { div, name, prev };
}

onMounted(() => {
	nextTick(() => {
		applyMenuTitlePatch();
		if (!titlePatch) requestAnimationFrame(applyMenuTitlePatch);
	});
});

onBeforeUnmount(resetMenuTitlePatch);

const templateMenus = inject('TEMPLATE_MENUS');
const getMenus = computed(() => templateMenus?.value || []);

const { viewMenuInFlowX } = useNavigation();
const changeMenu = menuInfo => {
	return viewMenuInFlowX(menuInfo.item);
};
</script>

<style lang="less" scoped>
.diagens-mob-menu-shell :deep(.diagens-mob-menu-brand-inline) {
	margin-left: 8px;
	color: #1d2129;
	font-size: 16px;
	font-weight: 500;
	line-height: normal;
}
</style>
